<div data-testid="create-invoice-dialog-confirmpopup" class="confirmpopup">
    <div data-testid="-create-invoice-dialog-dialog-title" mat-dialog-title>
      <label data-testid="create-invoice-dialog-title-label" class="title">Create Invoice</label>
    </div>
    <hr data-testid="create-invoice-dialog-first-hr">
    <div data-testid="create-invoice-dialog-dialog-content" mat-dialog-content>
      <p data-testid="create-invoice-dialog-content-p">"{{message}}"</p>
    </div>
    <hr data-testid="create-invoicedialog-second-hr">
    <div data-testid="create-invoicedialog-dialog-actions" mat-dialog-actions style="float: right;">
      <button
        data-testid="create-invoice-dialog-ok-button"
        type="submit" mat-raised-button
        (click)="okClick()"
        color="primary"
        cdkFocusInitial matTooltip="Create invoice"
        aria-label="Create invoice">
        <mat-spinner
        data-testid="create-invoice-dialog-spinner"
        color="accent"
        *ngIf="isLoadingSpinner"
        diameter="30">
      </mat-spinner>
        <span data-testid="create-invoice-dialog-ok-span" *ngIf="!isLoadingSpinner">Ok</span>
      </button>
      <button
        data-testid="create-invoice-dialog-no-button"
        mat-raised-button
        (click)="onNoClick()"
        color="warn">
        No
      </button>
    </div>
  </div>
